export function capitalize(value) {
    return (value.at(0).toUpperCase() + value.slice(1));
}
export function uncapitalize(value) {
    return (value.at(0).toLowerCase() + value.slice(1));
}
const encoder = new TextEncoder();
/**
 * Encodes a UTF-8 string into a buffer
 */
export function encodeUTF8(input) {
    return encoder.encode(input);
}
const decoder = new TextDecoder();
/**
 * Decodes a UTF-8 string from a buffer
 */
export function decodeUTF8(input) {
    if (!input)
        return '';
    if (input.buffer instanceof ArrayBuffer && !input.buffer.resizable)
        return decoder.decode(input);
    const buffer = new Uint8Array(input.byteLength);
    buffer.set(input);
    return decoder.decode(buffer);
}
export function encodeASCII(input) {
    const data = new Uint8Array(input.length);
    for (let i = 0; i < input.length; i++) {
        data[i] = input.charCodeAt(i);
    }
    return data;
}
export function decodeASCII(input) {
    let output = '';
    for (let i = 0; i < input.length; i++) {
        output += String.fromCharCode(input[i]);
    }
    return output;
}
export function decodeUUID(uuid) {
    const hex = Array.from(uuid)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export function encodeUUID(uuid) {
    const hex = uuid.replace(/-/g, '');
    const data = new Uint8Array(16);
    for (let i = 0; i < 16; i++) {
        data[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    }
    return data;
}
export function stringifyUUID(uuid) {
    const hex = uuid.toString(16).padStart(32, '0');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export function parseUUID(uuid) {
    return BigInt(`0x${uuid.replace(/-/g, '')}`);
}
